import { render, staticRenderFns } from "./BasicSkills.vue.html?vue&type=template&id=393df6dc&lang=html&external"
import script from "./BasicSkills.vue.js?vue&type=script&lang=js&external"
export * from "./BasicSkills.vue.js?vue&type=script&lang=js&external"
import style0 from "./BasicSkills.vue.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports